export default {
  SET_ISMOBILE (state, payload) {
    state.isMobile = payload
  },

  SET_MENUOPEN (state, payload) {
    state.menuOpen = payload
  },

  UPDATE_HOME (state, payload) {
    state.home = payload
  },

  UPDATE_ABOUT (state, payload) {
    state.about = payload
  },

  UPDATE_PRIVACY (state, payload) {
    state.privacy = payload
  },

  UPDATE_ACTIVITIES_LIST (state, payload) {
    state.activitiesList = payload
  },

  UPDATE_ACTIVITIES (state, payload) {
    state.activities[payload.slug] = payload
  },

  UPDATE_ACTIVITY_GROUPS(state, payload) {
    state.activityGroups[payload.slug] = payload
  },

  UPDATE_RESOURCES (state, payload) {
    state.resources[payload.slug] = payload
  },

  UPDATE_EVENTS_LIST (state, payload) {
    state.eventsList = payload
  },

  UPDATE_EVENTS (state, payload) {
    state.events[payload.slug] = payload
  },

  UPDATE_ARTWORKS_LIST (state, payload) {
    state.artworksList = payload
  },

  UPDATE_ARTWORKS (state, payload) {
    state.artworks[payload.slug] = payload
  },

  UPDATE_PEOPLE (state, payload) {
    state.people[payload.slug] = payload
  },

  UPDATE_TAGS (state, payload) {
    state.tags[payload.key] = payload.data
  },

  DISABLE_INTRO (state) {
    state.showIntro = false
  }
}